import { render, staticRenderFns } from "./ScreenLaudoTransvaginalUtero.vue?vue&type=template&id=4ac18876&lang=true&"
import script from "./ScreenLaudoTransvaginalUtero.vue?vue&type=script&lang=js&"
export * from "./ScreenLaudoTransvaginalUtero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports